import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 品牌企业列表
export const setBrandOrgs: Mutation<IModuleState> = (state, payload) => {
  state.brandOrgs.data = payload.data;
  state.brandOrgs.loading = !!payload.loading;
};

// 品牌企业的下辖品牌列表
export const setOrgBrands: Mutation<IModuleState> = (state, payload) => {
  state.orgBrands.data = payload.data;
  state.orgBrands.loading = !!payload.loading;
};

// 品牌门店列表
export const setBrandStores: Mutation<IModuleState> = (state, payload) => {
  state.brandStores.data = payload.data;
  state.brandStores.loading = !!payload.loading;
};

// 品牌门店列表
export const setStoreBrands: Mutation<IModuleState> = (state, payload) => {
  state.storeBrands.data = payload.data;
  state.storeBrands.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};


export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
